import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@material-ui/core";

const MultiSelectWithSelectAll = ({
  clientFields,
  newRuleField,
  newRuleAcceptable,
  setNewRuleAcceptable,
}) => {
  const options =
    clientFields.find((f) => f.name === newRuleField)?.acceptedValues || [];

  const handleChange = (event) => {
    const value = event.target.value;

    if (value.includes("all")) {
      // Toggle Select All
      if (newRuleAcceptable.length === options.length) {
        setNewRuleAcceptable([]); // deselect all
      } else {
        setNewRuleAcceptable(options); // select all
      }
    } else {
      setNewRuleAcceptable(value);
    }
  };

  const allSelected = options.length > 0 && newRuleAcceptable.length === options.length;

  return (
    <FormControl
      variant="outlined"
      size="small"
      style={{
        width: 350,
        "& .MuiOutlinedInput-root": { height: 40 },
      }}
    >
      <Select
        multiple
        displayEmpty
        value={newRuleAcceptable || []}
        onChange={handleChange}
        input={<OutlinedInput />}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <em>None</em>;
          }
          return selected.join(", ");
        }}
      >
        {/* Select All Option */}
        <MenuItem value="all">
          <Checkbox checked={allSelected} indeterminate={!allSelected && newRuleAcceptable.length > 0} />
          <ListItemText primary="Select All" />
        </MenuItem>

        {/* Individual Options */}
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            <Checkbox checked={newRuleAcceptable.includes(option)} />
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiSelectWithSelectAll;
